import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from "@angular/core";

@Component({
  selector: "icn-platforms-collapsible",
  templateUrl: "./platforms-collapsible.component.html",
  styleUrls: ["./platforms-collapsible.component.scss"],
})
export class PlatformsCollapsibleComponent {
  constructor(private changeDetectionRef: ChangeDetectorRef) {}

  @ViewChild("editableSpan") editableSpan: ElementRef;

  @Input() label;
  @Output() labelChange = new EventEmitter();
  @Input() isActive = true;
  @Output() isActiveChange = new EventEmitter();
  @Output() remove = new EventEmitter();
  editMode = false;
  @Input() isEditable;
  index = 0;
  trashIcon = "/assets/icons/pop-trash.svg";

  collapseToggle() {
    if (this.editMode) return;
    this.index ^= 1;
  }

  isOpen() {
    return this.index === 1;
  }

  checkToggle() {
    this.isActive = !this.isActive;
    this.isActiveChange.emit(this.isActive);
  }

  onDelete() {
    this.remove.emit();
  }

  onEnterPress(event) {
    if (event.keyCode !== 13) return;
    this.editModeExit(event);
    return false;
  }

  onChangeClick(event) {
    event.stopPropagation();
    this.editMode = true;
    this.editableSpan.nativeElement.setAttribute("contenteditable", true);
    this.editableSpan.nativeElement.focus();
  }

  editModeExit(event) {
    let self = this;
    this.labelChange.emit(event.target.textContent);
    setTimeout(() => {
      self.editMode = false;
      self.editableSpan.nativeElement.setAttribute("contenteditable", false);
      self.changeDetectionRef.markForCheck();
    }, 200);
  }
}
